import React from 'react';

import ObservedData from 'views/Meteorology/Fields/ObservedData';
import NumericForecast from 'views/Meteorology/Fields/NumericForecast';
import Comparator from 'views/Meteorology/Fields/Comparator';
import ClassicComparator from 'views/Meteorology/Fields/ClassicComparator';
import SynopticCharts from 'views/Meteorology/Fields/SynopticCharts';
import MeteorologyFieldsLayout from 'components/Layout/Meteorology/Fields';
import MeteorologyProtectedWrapper from 'components/RouteWrappers/Meteorology/Protected';
import trackingForecastRouter from './TrackingForecastRouter';
import modelPerformanceRouter from './ModelPerformanceRouter';

const fieldsRouter = {
  path: 'fields',
  element: <MeteorologyProtectedWrapper />,
  children: [
    {
      path: '',
      element: <MeteorologyFieldsLayout />,
      children: [
        trackingForecastRouter,
        modelPerformanceRouter,
        { path: 'observeddata', element: <ObservedData /> },
        { path: 'numericforecast', element: <NumericForecast /> },
        { path: 'comparator', element: <Comparator /> },
        { path: 'classiccomparator', element: <ClassicComparator /> },
        { path: 'synopticcharts', element: <SynopticCharts /> },
      ],
    },
  ],
};

export default fieldsRouter;
